/**
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Transfer, Tree, Steps, Tabs, Icon, Button,Modal,message} from 'antd';
import {Department} from '../setUp/department';
import {User} from '../setUp/user';
import {uuid} from "../../../utils";
import * as Actions from "../../../actions/allResources";
const { Step } = Steps;
const { TabPane } = Tabs;


export default class HoldAll extends Component {
    static defaultProps = {

        stepArray:['第一步','第二步','第三步'],
        tableData:['部门设置','用户设置'],
        showProcess:false,
        footer:'',
        bool:false,
        onChange:()=>{

        },
        shareSure:()=>{

        }
    };
    static propTypes = {
        title:PropTypes.string,//弹出框标题
        onChange:PropTypes.func,// 方法
        stepArray:PropTypes.array.isRequired, // 步骤条显示的文字
        tableData:PropTypes.array, // tab数据
        showProcess:PropTypes.bool.isRequired,// 是否显示进度条
        footer:PropTypes.string.isRequired,// 是否显示底部的确定按钮
        shareSure:PropTypes.func,// 方法
    };

    constructor(props) {

        console.log("constructor:     ");

        super(props);
        this.state = {
            currentProcess:'0',
            share:false,
            targetKeys:[],
            current:0,
            department:[],
            user:[],

        }
    }
    componentWillMount() {
        this.state.current = '0'
    }

    componentDidMount() {

    }

    modalKey = uuid();

    show(refreshKey){
        if(refreshKey){
            this.modalKey = uuid();
        }
        console.log("show:            ");
        this.setState({
           currentProcess:'0',
           share:true,
           current:'0'
        })
    }
    render() {
        const { targetKeys } = this.props;

        return (
            <Modal
                title={this.props.title}
                centered
                key={this.modalKey}
                width={'813px'}
                footer={null}
                visible={this.state.share}
                onCancel={this.handleCancel}
            >
                <div>
                    <div style={{height:'600px',margin:'0 auto'}}>
                        {
                            this.state.currentProcess === '2'?
                                <div>
                                    <div style={{margin:'0 auto',width:'80px'}}><Icon type="check-circle"  style={{fontSize:'80px',color:'#0050B3'}}/></div>
                                    <div style={{fontSize: '24px', color: '#666666', textAlign: 'center', lineHeight: '24px',marginTop:40}}>分享完成</div>
                                </div>
                                :<div>
                                    <Tabs activeKey={this.state.current}  style={{marginBottom:'20px'}} onChange={this.change}>
                                        {
                                            this.props.tableData.map((item,index)=>{
                                                return(<TabPane tab={item} key={index}/>)
                                            })
                                        }
                                    </Tabs>
                                    <div>
                                        <div style={{display:this.state.current ==='0'?"block":"none"}}>
                                            <Department callbackData={(data)=>
                                                this.setState({department:data})
                                            }/>
                                        </div>
                                        <div style={{display:this.state.current ==='1'?"block":"none"}}>
                                            <User updata={false} callbackUserData={(data)=>{
                                                this.setState({user:data})
                                                this.state.user = data;

                                            }}/>
                                        </div>
                                    </div>
                                    <div style={{textAlign: 'right', marginTop: 20}}><Button type="primary" onClick={this.saveCallback}>确定</Button>
                                    </div>
                                </div>
                        }
                    </div>
                </div>
            </Modal>
        )
    }
    saveCallback=()=>{

        console.log(this.state.department,this.state.user)
        this.props.onSaveCallback&&this.props.onSaveCallback(this.state.department,this.state.user)
        if(this.state.department.length|| this.state.user.length){
            this.setState({share: false});
        }else{
         message.error('请至少选择一个要分享的部门或者用户!')
        }

        this.state.department = [];
        this.state.user = [];
        this.setState({})
    };
    change=(key)=>{
       this.setState({current:key})
    };
    handleCancel = e => {
        this.setState({share: false});
    };


}